<!-- 资源选择 -->
<template>
    <el-dialog @close="close" title="资源选择" :visible.sync="centerDialogVisible" width="35%" center append-to-body>
        <div class="main">
            <div class="mainLine" v-for="(items, keys) in dataArr" :key="keys">
                <el-radio :label="keys" v-model="radio">
                    <div class="mainLineBox">
                        <div @click.stop="handlerSeeResClick(item)" class="mainLineBlock" v-for="(item, index) in items"
                            :key="index">
                            {{ item.resourceName ? item.resourceName : item.resourceNameEn }}(
                            <span v-for="(n, m) in item.orderListDetailResultList">
                                {{ n.productName }}{{ n.number + n.priceCompany }}<span
                                    v-if="m !== item.orderListDetailResultList.length - 1">、</span>
                            </span>)
                        </div>
                    </div>
                </el-radio>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
        </span>
        <ResourceDetail ref="resourceDetail"></ResourceDetail>
    </el-dialog>
</template>

<script>
import OrderApi from '@/components/Api/order.js'
import { getGroup } from '@/assets/utils/unit.js'
import ResourceDetail from '@/views/plan/info/ResourceDetail.vue'
import Api from "@/components/Api";
import { Loading } from 'element-ui';
export default {
    components: {
        ResourceDetail
    },
    data() {
        return {
            radio: null,
            centerDialogVisible: false,
            dataArr: {}
        }
    },
    computed: {},
    watch: {},
    methods: {
        //查看资源详情
        handlerSeeResClick(item) {
            //如果等于会议
            if (item.state === 1) {
                new Api("resource").siteDetail(item.resourceId).then(res => {
                    if (res.status === 200) {
                        this.$refs.resourceDetail.init(res.data)
                    }
                })
            } else {
                let resourceInfoRequest = { "productType": 2, "id": item.resourceId, "state": item.state }
                this.$refs.resourceDetail.init(resourceInfoRequest)
            }
        },
        initClick(data) {
            console.log('data',data)
            let obj = this.mergeAndReplaceKey(getGroup(data, 'sengFlag'))
            this.centerDialogVisible = true
            for (let key in obj) {
                let groupedData = obj[key].reduce((result, currentItem) => {
                    let groupKey = currentItem.resourceId;
                    if (!result[groupKey]) {
                        result[groupKey] = { ...currentItem, orderListDetailResultList: [] };
                    }
                    currentItem.orderListDetailResultList.forEach((item) => {
                        let existingItem = result[groupKey].orderListDetailResultList.find((i) => i.productName === item.productName);
                        if (existingItem) {
                            existingItem.number += item.number; // 合并数量
                        } else {
                            result[groupKey].orderListDetailResultList.push({ ...item });
                        }
                    });
                    return result;
                }, {});
                this.dataArr[key] = Object.values(groupedData);
            }
        },
        mergeAndReplaceKey(data) {
            const newData = {};
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const items = data[key];
                    // 合并orderChildrenId并作为新键名
                    const mergedKey = items.map(item => item.orderChildrenId).join(',');
                    // 替换原有键名
                    newData[mergedKey] = items;
                }
            }

            return newData;
        },
        //查看资源详情
        handlerSeeDetail(item) {
            console.log(item, '看看的姐姐姐姐');
        },
        close() {
            this.radio = ''
            this.dataArr = {}
        },
        save() {
            console.log(this.radio, '时刻打开打开的');
            if (!this.radio) {
                this.$message.error('请选择资源')
            } else {
                let ids = this.radio.split(',')
                console.log(ids,"lsksdkjfksjdkfjksdjkf")
                new OrderApi("order")
                    .platformConfirmsBudgetResources(ids)
                    .then((res) => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "保存成功!",
                            });
                            this.$emit('updateList')
                            this.centerDialogVisible = false
                        } else {
                            this.$message.error(res.statusText)
                        }
                    });
            }
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-radio {
    display: flex;
    align-items: center;
    width: 100%;
}

.main {
    .mainLine {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // height: 0.4rem;
        border-bottom: 1px dotted #ccc;
        padding: 0.1rem 0.3rem;

        .mainLineBox {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .mainLineBlock {
                margin-right: 0.1rem;
                line-height: 0.25rem;

                &:nth-last-child(1) {
                    margin-right: 0;
                }
            }
        }

        &:nth-child(1) {
            border-top: 1px dotted #ccc;
        }
    }
}
</style>